import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EcommerceComponent } from './ecommerce.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'ecommerce-view/:id',
        redirectTo: 'ecommerce-view/:id/overview',
        pathMatch: 'full',
        resolve: { permissions: PermissionsResolver },
      },
      {
        path: 'ecommerce-view/:id/:segment',
        component: EcommerceComponent,
        canActivate: [AuthGuard],
        resolve: { permissions: PermissionsResolver },
      },
    ])
  ],
  exports: [RouterModule],
})
export class EcommerceRoutingModule { }
